import List from './List.component'

export default List
